/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UNLIKEFEED= createAsyncThunk(
  "unlikeFeed/unlikeFeed",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const unlikeFeedSlice = createSlice({
  name: "unlikeFeedSlice",
  initialState: {
    unlikeFeed: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfunlikeFeed: (state) => {
        state.unlikeFeed.loading = false
        state.unlikeFeed.error = false
        state.unlikeFeed.data = []
        state.unlikeFeed.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UNLIKEFEED.fulfilled, (state, action) => {
      state.unlikeFeed = {
        ...state.unlikeFeed,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UNLIKEFEED.pending, (state, action) => {
      state.unlikeFeed = {
        ...state.unlikeFeed,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UNLIKEFEED.rejected, (state, action) => {
      state.unlikeFeed = {
        ...state.unlikeFeed,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const unlikeFeedAction = {
    UNLIKEFEED,
};

export { unlikeFeedAction };
export default unlikeFeedSlice.reducer;
export const {setInitialStateOfunlikeFeed} = unlikeFeedSlice.actions